package com.klantenstop.web.data.models.domain

import com.klantenstop.web.data.models.dto.responses.moderation.ModerationActionType
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationEntityType
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationEntryDto
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationStatus

data class ModerationEntry(
    val id: String,
    val entityType: ModerationEntityType,
    val entityId: String,
    val snapshotId: String,
    val actionType: ModerationActionType,
    val status: ModerationStatus,
    val submittedByUserId: String?,
    val createdAt: String,
    val entityName: String? = null,
    val submitterName: String? = null,
)

fun ModerationEntryDto.toModerationEntry() = ModerationEntry(
    id = id,
    entityType = entityType,
    entityId = entityId,
    snapshotId = snapshotId,
    actionType = actionType,
    status = status,
    submittedByUserId = submittedByUserId,
    createdAt = createdAt,
    entityName = entityName,
    submitterName = submittedByUserName,
)
